<template>
	<div class="advert-group">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('cAdvertGroup.title')"
			:visible.sync="dialogAdvertGroup"
			width="50%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				height="450"
				:data="advertList"
				style="width: 100%">
				<el-table-column
					prop="display"
					:show-overflow-tooltip="true"
					:formatter="formatterShowType"
					:label="$t('cAdvertGroup.showType')"
					width="120"></el-table-column>
				<el-table-column :label="$t('cAdvertGroup.content')" width="120">
					<template slot-scope="scope">
						<template v-if="scope.row.type == 0">
							<el-tooltip
								class="item"
								effect="dark"
								:content="$t('cAdvertGroup.big')"
								placement="top-start">
								<el-image
									style="height: 102px"
									:preview-src-list="imageList"
									:src="scope.row.url"
									fit="cover"></el-image>
							</el-tooltip>
						</template>
						<template v-else>
							<video
								:src="scope.row.url"
								:controls="true"
								style="
									width: 120px !important;
									height: 100px !important;
								"></video>
						</template>
					</template>
				</el-table-column>
				<el-table-column
					prop="head"
					:show-overflow-tooltip="true"
					:label="$t('cAdvertGroup.aTitle')"
					width="160"></el-table-column>
				<el-table-column
					prop="advertiser"
					:show-overflow-tooltip="true"
					:label="$t('cAdvertGroup.advertiser')"
					width="150"></el-table-column>
				<el-table-column
					prop="startTime"
					:formatter="(row) => $formatDate(row.startTime)"
					:show-overflow-tooltip="true"
					:label="$t('cAdvertGroup.startTime')"
					width="180"></el-table-column>
				<el-table-column
					prop="endTime"
					:formatter="(row) => $formatDate(row.endTime)"
					:show-overflow-tooltip="true"
					:label="$t('cAdvertGroup.endDate')"
					width="180"></el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.close") }}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "AdvertGroup",
	props: {
		advertGroupId: String,
		dialogAdvertGroup: Boolean,
		showType: Array,
	},
	data() {
		return {
			advertList: [],
			loading: false,
			imageList: [],
		};
	},
	methods: {
		closeDialog() {
			this.cancel();
		},
		openDialog() {
			this.loading = true;
			this.$api
				.request(this.$url.Adverts.listAdvertByGroupId, this.$method.get, {
					advertGroupId: this.advertGroupId,
				})
				.then(res => {
					if (res.code === 0) {
						this.advertList = res.data;
						this.showImage(res.data);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		cancel() {
			this.$emit("cancelAdvertGroup", false);
		},
		formatterShowType(row) {
			return this.$cloud.getDictLabel(this.showType, row.display);
		},
		showImage(data) {
			data.forEach(k => {
				if (k.showImage) {
					this.imageList.push(k.showImage);
				}
			});
		},
	},
};
</script>

<style scoped></style>
